import * as tslib_1 from "tslib";
import TextInput from '../TextInput';
import styled from '../styles';
var QuickJumpInput = styled(TextInput)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 52px;\n  font-size: 0.75rem;\n"], ["\n  width: 52px;\n  font-size: 0.75rem;\n"])));
export default QuickJumpInput;
var templateObject_1;
//# sourceMappingURL=QuickJumpInput.js.map